import { defineStore } from "pinia";

interface IState {
  isGlobalLoading: boolean;
}

export const useLayoutStore = defineStore("layout", {
  state: (): IState => {
    return {
      isGlobalLoading: false,
    };
  },
});
